import { TRenderCellData } from 'shared/types/types';
import { ExclamationMark } from 'shared/components/exclamationMark';
import { RolesUser } from 'shared/enums';

import { TReferencesInfo } from 'shared/types/reference.types';
import style from './index.module.scss';

const RenderCellWithWarning = ({ value, currentRole, arr }: TRenderCellData) => {
  // инициализация
  let hasWarning = false;
  // массив справок
  const referencesInfo = arr?.data || [];
  if (referencesInfo?.length) {
    const currentReference = referencesInfo.find((i: TReferencesInfo) => i.id === value);
    if (currentReference) {
      // проверяю условие, что бухгалтерия отфутболила заявку обратно,
      // если да, то помечаю знаком
      if (currentReference?.accountant !== null && currentReference?.status === 'transferred_to_hr') {
        if (currentRole === RolesUser.HRDirector || currentRole === RolesUser.Consultant) hasWarning = true;
      }
    }
  }

  return (
    <div className={style.cellBody}>
      <span>{value}</span>
      {hasWarning && <ExclamationMark />}
    </div>
  );
};
export default RenderCellWithWarning;
